import styled from 'styled-components';
import { Button, Col } from 'elmo-elements';

export const Header = styled.div`
  display: flex;
`;

export const LayoutWrapper = styled.div`
  width: 100%;
  overflow-x: hidden;
  display: flex;
  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.14);
  height: 100vh;

  background-image: url(./people.png);
  background-attachment: fixed;
  background-position: 50% 102%;
  background-size: 65%;
  background-repeat: no-repeat;

  .elmo-layout__main-content-wrapper {
    width: 100%;
  }
`;

export const ReasonHeading = styled.div`
  padding: 0;
  margin: 54px 0 30px 0 !important;

  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) and (-webkit-min-device-pixel-ratio: 2) {
    margin: 70px 0 30px 0 !important;

    h4 {
      margin: 0 0 30px 0;
    }
  }

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
    margin: 70px 0 30px 0 !important;

    h4 {
      margin: 0 0 50px 0;
    }
  }

  h4 {
    font-size: 33px !important;
    color: #212121 !important;
    font-weight: bold !important;
    margin: 0 0 46px 0;
    span {
      color: #8c8c8c;
    }
  }
`;

export const ButtonWrapper = styled.div`
  text-align: center;
  margin: 40px 0 0 0;

  & > button.elmo-btn--is-disabled {
    border: 1px solid #dcdcdc;
  }
`;

export const FormBackdrop = styled(Col)`
  padding-bottom: 40px;
`;

export const StyledButton = styled(Button)`
  width: 150px;
`;

export const Error = styled.div`
  color: #ff0000;
  font-size: 14px;
  margin-top: 10px;
`;

export const StyledTextArea = styled.div`
  margin-top: 10px;
`;
